const apiBase = {
  statistics: '/api/stat/add',//PU,UV
  queryBannerList: '/api/banner/queryBannerList',//获取banner
  queryNewsList: '/api/show/queryInfoPage',//获取新闻list
  queryNewsInfo: '/api/show/queryInfoDetail',//获取新闻info

  

}
let NewsSeverObject = null
class NewsSever {
  constructor() {}
  statistics(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.statistics,
      data: params
    })
  }
  queryBannerList(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryBannerList,
      data: params
    })
  }
  queryNewsList(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryNewsList,
      data: params
    })
  }
  queryNewsInfo(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryNewsInfo,
      data: params
    })
  }
}

function singleNewsSever() {
  if (NewsSeverObject === null) {
    NewsSeverObject = new NewsSever()
  }
  return NewsSeverObject
}
export default singleNewsSever()